import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router';

import { incidentListRoute } from '@/features/shared/routes';
import {
  closeIncident as closeIncidentCommand,
  openAddAgencyToIncidentDialog,
  openShareByLinkDialog as openShareByLinkDialogAction,
} from './actions';
import { useActionsMobileMenuContainer } from './layout/actionsMobileMenu';
import { IncidentDetailActionBarItems } from './IncidentDetailActionBarItems';

export type IncidentDetailActionBarProps = {
  incidentIsReadOnly: boolean;
  incidentId: string;
};

export function IncidentDetailActionBar({ incidentIsReadOnly, incidentId }: IncidentDetailActionBarProps) {
  const actionsMobileMenuContainer = useActionsMobileMenuContainer();
  const navigate = useNavigate();

  const openShareByLinkDialog = () => {
    openShareByLinkDialogAction(incidentId);
  };

  const closeIncident = async () => {
    await closeIncidentCommand(incidentId);
    void navigate(incidentListRoute());
  };

  const addAgencyToIncident = () => {
    openAddAgencyToIncidentDialog(incidentId);
  };

  return (
    <>
      <div className="d-none d-tablet-flex flex-wrap justify-content-end gap-1 align-items-center mb-2">
        <IncidentDetailActionBarItems
          incidentId={incidentId}
          incidentIsReadOnly={incidentIsReadOnly}
          onAddAgencyToIncident={addAgencyToIncident}
          onCloseIncident={closeIncident}
          onOpenShareByLinkDialog={openShareByLinkDialog}
        />
      </div>

      {actionsMobileMenuContainer !== null &&
        createPortal(
          <div className="d-flex flex-column p-2 gap-2">
            <IncidentDetailActionBarItems
              incidentId={incidentId}
              incidentIsReadOnly={incidentIsReadOnly}
              onAddAgencyToIncident={addAgencyToIncident}
              onCloseIncident={closeIncident}
              onOpenShareByLinkDialog={openShareByLinkDialog}
            />
          </div>,
          actionsMobileMenuContainer,
        )}
    </>
  );
}
